import { StyleSheet } from "react-native";

import type { UiTheme } from "../theme";

// Shared Settings card primitives — the card shell + its label/help/value
// text + the secondary/danger action buttons. Lifted verbatim from the
// mobile profileStyles so the measurement Form/History (and future lifted
// Settings cards) render identically on mobile and the web console.

export function makeSettingsCardStyles(theme: UiTheme) {
  const { palette: p, spacing: s, radius: r, typography: t } = theme;
  return StyleSheet.create({
    card: {
      backgroundColor: p.surface,
      borderColor: p.border,
      borderWidth: 1,
      borderRadius: r.r3,
      paddingHorizontal: s.s5,
      paddingVertical: s.s4,
      gap: s.s2,
    },
    cardLabel: {
      color: p.ink2,
      fontSize: t.sizes.sm,
      fontWeight: "700",
      letterSpacing: 0.2,
    },
    cardValue: { color: p.ink, fontSize: t.sizes.base },
    cardHelp: { color: p.ink3, fontSize: t.sizes.sm },
    secondaryAction: {
      borderColor: p.border,
      borderWidth: 1,
      borderRadius: r.r3,
      paddingVertical: s.s4,
      alignItems: "center",
      marginTop: s.s3,
    },
    secondaryActionPressed: { backgroundColor: p.surface2 },
    secondaryActionText: { color: p.ink, fontSize: t.sizes.base, fontWeight: "600" },
    dangerAction: {
      borderColor: p.danger,
      borderWidth: 1,
      borderRadius: r.r3,
      paddingVertical: s.s4,
      alignItems: "center",
    },
    dangerActionPressed: { backgroundColor: p.dangerFill },
    dangerActionText: { color: p.danger, fontSize: t.sizes.base, fontWeight: "600" },
    disabled: { opacity: 0.5 },
  });
}
